import { t } from "i18next";

export enum TABLE_ITEM_LAYOUT_TYPE {
  CHAT_HISTORY = 1,
  FAQ = 2,
  TERMS_CONDITIONS = 3,
  PRIVACY_POLICY = 4,
  SUGGESTED_QUESTION = 5,
  PAYMENT_METHODS = 6,
}

export enum SUBSCRIPTION_TYPE {
  MONTHLY = 1,
  YEARLY = 2,
}

export enum SUBSCRIPTIONS_TYPE {
  MONTHLY = "Monthly",
  YEARLY = "Yearly",
}

export enum APP_THEME {
  DARK = "dark",
  Light = "light",
  SYSTEM = "system",
}

export enum MENU_TYPE {
  PROFILE = 1,
  LOGOUT = 2,
  THEME = 3,
}
export enum ACTION {
  DELETE = "delete",
  EDIT = "edit",
}

export enum ASSESSMENT_TYPE_TABS {
  CREATED = "created",
  UPLOADED = "uploaded",
}

// Numeric mapping for API payloads
export enum ASSESSMENT_TYPE_PARAM {
  CREATED = 1,
  UPLOADED = 2,
}

export enum PDF_LOADING_ACTION {
  NEW_TAB = "newTab",
  MODAL = "modal",
}

export const DATA_SOURCE_TABS = [
  { label: "assessments.dataSourceTabs.incidentHistory", index: 0 },
  { label: "assessments.dataSourceTabs.chemicalDatabase", index: 1 },
  { label: "assessments.dataSourceTabs.safetyRegulations", index: 2 },
] as const;

export const REQUIREMENTS = [
  "common:password.length",
  "common:password.combination",
  "common:password.upperCase",
  "common:password.lowerCase",
  "common:password.numbers",
  "common:password.specialCharacters",
];

export const SELECTED_PROFILE_TYPES = {
  PROFILE: "profile",
  PASSWORD: "password",
};

export enum PRIVACY_CONTENT_TYPE {
  TABLE = 1,
}

export const TOAST_VARIANT = {
  ERROR: "error",
  SUCCESS: "success",
  COPY_SUCCESS: "copy_success",
  INFO: "warning",
  WARNING: "warning",
};

export const TOAST_VARIANT_COLORS: allAnyTypes = {
  [TOAST_VARIANT.ERROR]: {
    borderColor: "#F6C23A",
    textColor: "#18191B",
    backgroundColor: "rgba(246, 194, 58, 0.2)",
  },
  [TOAST_VARIANT.SUCCESS]: {
    borderColor: "#40DC91",
    textColor: "#18191B",
    backgroundColor: "#EEFFF7",
  },
  [TOAST_VARIANT.COPY_SUCCESS]: {
    textColor: "#FFFFFF",
    backgroundColor: "#2F3438",
  },
  [TOAST_VARIANT.INFO]: {
    borderColor: "#50B7F0",
    textColor: "#18191B",
    backgroundColor: "#EEF9FF",
  },
  [TOAST_VARIANT.WARNING]: {
    borderColor: "#F6C23A",
    textColor: "#18191B",
    backgroundColor: "#FFFAEC",
  },
};

export const LOADER_STYLES = {
  size: "xl",
  color: "blue",
  thickness: "4px",
};

export const PAGINATION_DEFAULTS = {
  PAGESIZE: 10,
  THREAD_PAGE_SIZE: 10,
  DOCUMENT_LIST: 20,
  MAX: 100,
};

export const enum TABS_VARIANT {
  DEFAULT = "default",
  CTA = "cta",
}
export const RECORDS_PER_PAGE = 10;
export const FILES_PER_PAGE = 5;
export const DOCUMENTS_FILTER = "Recents";

export const enum RESPONSE_STATUS {
  SEARCH = "search",
  FILE = "file",
  WEBPAGE = "webpage",
  YOUTUBE = "youtube",
  DEEP_SEARCH = "deepsearch",
}

export const enum CHATBOT_TYPE {
  LAW_CHATBOT = "1",
  PROJECT_DOCUMENT_CHATBOT = "4",
  DRAWING_ANALYSIS_CHATBOT = "5",
  MULTI_DOCUMENT_CHATBOT = "3",
}

export const FILE_STATUS = {
  PROCESSING: "processing",
  COMPLETED: "completed",
  FAILED: "failed",
};

export const CHAT_MODE = {
  PROJECT: "project",
  INTEGRATED: "integrated",
};
export const getChatOptions = () => [
  {
    value: "chat",
    label: t("common:projects.lawMode"),
  },
  {
    value: "search",
    label: t("common:projects.lawCaseMode"),
  },
];

export const getDocChatOptions = () => [
  {
    value: "integrated",
    label: t("common:projects.integratedMode"),
  },
  {
    value: "project",
    label: t("common:projects.projectMode"),
  },
];

export enum VIEW_TYPE {
  PROJECT = "project",
  FOLDER = "folder",
  DOCUMENT = "document",
}

export enum TAB_TYPES {
  REPORT_HISTORY = 1,
  CHAT_HISTORY = 2,
}

export const CHAT_TYPE = {
  LAW_CHATBOT: 1,
  DOCUMENT_QUERY: 2,
  MULTI_DOCUMENTS_QUERY: 3,
  PROJECT_CHATBOT: 4,
  DRAWING_ANALYSIS_CHAT: 5,
  KCS: 6,
};

export enum DOCUMENT_TYPE {
  DOCUMENT = "document",
  CHECKLIST = "checklist",
}

export const FILE_TYPE = {
  SIMPLE_FILE: 1,
  EXTRACTION_REVIEW: 2,
  EXCEL_AUTO_COMPLETE: 3,
  DRAWING_ANALYSIS: 4,
  FINISHING_MATERIAL_REQUEST: 5,
};

export const FINISHING_MATERIAL_SUBTYPE = {
  DRAWING_FILE: 1,
  CONTRACT_FILE: 2,
};

// Re-export the comprehensive file size formatter from utils
export { formatFileSizeSmart as formatFileSize } from "@root/utils/file-size-helper";

// Relative time formatter
export const timeAgo = (date: Date) => {
  const diff = Math.floor((Date.now() - date.getTime()) / 1000); // in sec
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  return `${Math.floor(diff / 86400)} d ago`;
};

export const DOCUMENT_STATUS = {
  PROCESSING: [0, 1, 2, 3, 4, 5, 6, 7, 10],
  COMPLETED: 8,
  ERROR: 9,
};

export const FINISHING_MATERIAL_STATUS = {
  PROCESSING: [0, 1, 2, 3, 4, 5, 6, 7, 10],
  COMPLETED: 8,
  ERROR: 9,
};

export const MODULE_TYPE = {
  FILE: "FILE",
  CHAT: "CHAT",
};

export const USER = "user";
export const AI = "ai";
export const STRING = "string";
// For styling the citations in the markdown (Reference Texts)
export const ENGLISH_TRANSLATION = "English Translation:";
export const ORIGINAL_TEXT_KOREAN = "Original Text (Korean):";
export const RISK_ENGLISH = "Risk";
export const RISK_KOREAN = "위험도";
export const RISK_2_KOREAN = "위험성";

export const CHAT_STATUS = {
  PENDING: 0,
  START: 1,
  VECTOR_STORE: 2,
  STREAMING: 3,
  COMPLETE: 4,
  EXCEPTION: 5,
  FOLLOW_UP: 6,
  NO_CHANGE: 7,
  SOURCE: 8,
};

export const RISK_ASSESSMENT_STATUS = {
  PENDING: 0,
  START: 1,
  RISK_VS_DOCS: 2,
  STREAMING: 3,
  STREAMING_COMPLETED: 4,
  EXCEPTION: 5,
  ACCIDENT_QUERIES_GENERATION: 6,
  COMPLETED: 7,
  ACCIDENT_VS_DOCS: 8,
  SIMILAR_ACCIDENT_LIST: 9,
  CHEMICAL_QUERIES_GENERATION: 10,
  CHEMICAL_VS_DOCS: 11,
  SIMILAR_CHEMICAL_RECORDS: 12,
  LAW_QUERIES_GENERATION: 13,
  LAW_VS_DOCS: 14,
  SAFETY_REGULATIONS_GENERATION: 15,
  SOURCES: 16,
};

export const ASSESSMENT_PENDING_STATUSES = [
  RISK_ASSESSMENT_STATUS.START,
  RISK_ASSESSMENT_STATUS.RISK_VS_DOCS,
];

export const ASSESSMENT_PROCESSING_STATUSES = [
  RISK_ASSESSMENT_STATUS.STREAMING,
  RISK_ASSESSMENT_STATUS.STREAMING_COMPLETED,
  RISK_ASSESSMENT_STATUS.ACCIDENT_QUERIES_GENERATION,
  RISK_ASSESSMENT_STATUS.ACCIDENT_VS_DOCS,
  RISK_ASSESSMENT_STATUS.SIMILAR_ACCIDENT_LIST,
  RISK_ASSESSMENT_STATUS.CHEMICAL_QUERIES_GENERATION,
  RISK_ASSESSMENT_STATUS.CHEMICAL_VS_DOCS,
  RISK_ASSESSMENT_STATUS.SIMILAR_CHEMICAL_RECORDS,
  RISK_ASSESSMENT_STATUS.LAW_QUERIES_GENERATION,
  RISK_ASSESSMENT_STATUS.LAW_VS_DOCS,
  RISK_ASSESSMENT_STATUS.SAFETY_REGULATIONS_GENERATION,
];

export const ASSESSMENT_REVIEW_STATUSES = {
  START: 1,
  DOWNLOADED_PDF_FILE: 2,
  STREAMING: 3,
  READ_FILE_CONTENT: 4,
  EXCEPTION: 5,
  ACCIDENT_VS_DOCS: 6,
  COMPLETED: 7,
  CHEMICAL_VS_DOCS: 8,
  RULES_VS_DOCS: 9,
  IRRELEVANT_DOC: 10,
};

// Statuses that should continue polling for uploaded assessments (excludes EXCEPTION: 5, COMPLETED: 7, and IRRELEVANT_DOC: 10)
export const ASSESSMENT_REVIEW_PROCESSING_STATUSES = [
  ASSESSMENT_REVIEW_STATUSES.START,
  ASSESSMENT_REVIEW_STATUSES.DOWNLOADED_PDF_FILE,
  ASSESSMENT_REVIEW_STATUSES.STREAMING,
  ASSESSMENT_REVIEW_STATUSES.READ_FILE_CONTENT,
  ASSESSMENT_REVIEW_STATUSES.ACCIDENT_VS_DOCS,
  ASSESSMENT_REVIEW_STATUSES.CHEMICAL_VS_DOCS,
  ASSESSMENT_REVIEW_STATUSES.RULES_VS_DOCS,
];

export const AI_MODEL_OPTIONS = [
  { id: 1, labelKey: "aiModelOptions.msdsChemicalHazard" },
  { id: 2, labelKey: "aiModelOptions.incidentPatternRecognition" },
  { id: 3, labelKey: "aiModelOptions.riskAssessment" },
  { id: 4, labelKey: "aiModelOptions.regulatoryComplianceCheck" },
  { id: 5, labelKey: "aiModelOptions.dynamicRiskScoring" },
];

export const CHAT_MODEL_TYPE = {
  MULTI_PROMPT: 1,
  ASK_AI: 2,
  LEGAL_COMPLIANCE: 3,
};

export const RECOMMENDATION_CARD_CONFIGS = [
  {
    borderColor: "#DE7F04",
    bgColor: "#FEFAF5",
    boxShadow: "0px 4px 10px 0px #DE7F0426",
  },
  {
    borderColor: "#3AB65A",
    bgColor: "#ECFDF3",
    boxShadow: "0px 4px 10px 0px #3AB65A26",
  },
  {
    borderColor: "#DC3545",
    bgColor: "#FDF3F4",
    boxShadow: "0px 4px 10px 0px #DC354526",
  },
];

export const POLLING_INTERVAL = 1000;
export const HIDE_POLLING_SPINNER_DELAY = 500;
export const COPY_DELAY = 1500;
export const RISK_ASSESSMENT_POLLING_INTERVAL = 10000;
export const STREAMING_TIMEOUT = 2000;
export const MAX_VISIBLE_CHIPS = 3;
export const PENDING_STATUS = "pending";
export const ASSESSMENT_TYPE_QUERY_PARAM = "assessmentType";
export const ASSESSMENT_ID_QUERY_PARAM = "assessmentId";

export enum ChipType {
  MATERIALS = "materials",
  EQUIPMENTS = "equipments",
}

export const ASSESSMENT_TYPE = {
  ASSESSMENT: 1,
  FILE_ASSESSMENT: 2,
};

// Risk cell coloring thresholds and colors for markdown tables
export const RISK_CELL = {
  LOW_MAX: 4, // <= 4 → green
  HIGH_MIN: 8, // >= 8 → red
  COLORS: {
    GREEN: "#DCFCE7",
    YELLOW: "#FEF9C3",
    RED: "#FEE2E2",
  },
};
